import React, { useState, useEffect } from 'react';
import { Form, Button, Container, Row, Col, Card } from 'react-bootstrap';

import { useTables } from "./TableManagement/components/useTables";
import { useLanguages } from "./TableManagement/components/useLanguages";

import "../css/HomePage.css";

import targaCE1 from '../img/CE_1.png';
import targaCE2 from '../img/CE_2.png';
import targaUL1 from '../img/UL_1.png';
import targaUL2 from '../img/UL_2.png';

function HomePage() {


  const [typeLicense, setTypeLicense] = useState('');

  const { languages } = useLanguages(process.env.REACT_APP_API_URL);
  const [language, setLanguage] = useState('')

  const { tables: typeMachine } = useTables(process.env.REACT_APP_API_URL);
  const [typeMachineSelected, setTypeMachineSelected] = useState('');

  const [snMachine, setSnMachine] = useState('');

  const [laserOptions, setLaserOptions] = useState([]);
  const [typeLaser, setTypeLaser] = useState('');

  const [voltage, setVoltage] = useState('');

  const [frequency, setFrequency] = useState('');

  const [results, setResults] = useState(null);

  const [Img1, setImg1] = useState(null);
  const [Img2, setImg2] = useState(null);

  const [submittedData, setSubmittedData] = useState(null);


  useEffect(() => {
    if (typeLicense !== "CE" && frequency === "50") setFrequency("");
  }, [typeLicense, frequency, voltage]);



  // Recupero i possibili elementi del laser in base alla macchina selezionata
  useEffect(() => {
    const fetchLaserTypes = async () => {
      if (!typeMachineSelected) {
        setLaserOptions([]);
        setTypeLaser("");
        return;
      }

      try {
        const res = await fetch(`${process.env.REACT_APP_API_URL}/laser-types/${typeMachineSelected}`);
        if (!res.ok) throw new Error("Errore nel caricamento dei laser");
        const data = await res.json();
        setLaserOptions(data.laser_types || []);
      } catch (err) {
        console.error(err);
        setLaserOptions([]);
      }
    };

    fetchLaserTypes();
  }, [typeMachineSelected]);



  // Logica del form
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!Number.isInteger(Number(frequency)) || !Number.isInteger(Number(voltage))) {
      alert("Frequenza e Tensione devono essere numeri interi.");
      return;
    }

    if (!snMachine.includes(".")) {
      alert("Il serial number deve essere nel formato AA.BB.CC.DD");
      return;
    }

    if (!snMachine.includes(typeMachineSelected)) {
      alert("Il serial number non sembra combaciare con la tipologia macchina selezionata.");
      return;
    }



    setResults(null);
    const formData = new URLSearchParams();   
    formData.append("typeLicense", typeLicense);
    formData.append("typeLanguage", language)
    formData.append("snMachine", snMachine);
    formData.append("typeLaser", typeLaser);
    formData.append("voltage", voltage);
    formData.append("frequency", frequency);

    const API_URL = process.env.REACT_APP_API_URL;

    try {
      const res = await fetch(`${API_URL}/selectDB`, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: formData.toString(),
      });

      const data = await res.json();
      setResults(data);

      console.log("dataQuery", data)

      if (typeLicense === "UL") {
        setImg1(targaUL1);
        setImg2(targaUL2);
      } else {
        setImg1(targaCE1);
        setImg2(targaCE2);
      }

      setSubmittedData({
        typeLicense,
        language,
        snMachine,
        typeLaser,
        voltage,
        frequency
      });

      // Reset dei campi
      setTypeLicense("");
      setLanguage("")
      setTypeMachineSelected("")
      setSnMachine("");
      setTypeLaser("");
      setVoltage("");
      setFrequency("");
      setTypeMachineSelected("")


    } catch (err) {
      alert(err.message);
    }
  };


  return (
    <Container className="mt-5">
      {/* Titolo pagina */}
      <div className="page-header text-center mb-5">
        <h1 className="display-6 text-primary">ANALISI DATI TARGA</h1>
        <hr className="mx-auto" style={{ width: "500px", borderTop: "2px solid #012459ff", opacity: "0.7" }} />
      </div>

      <Row className="g-4 justify-content-center align-items-start">
        
        {/* COLONNA SINISTRA — FORM + RIEPILOGO */}
        <Col xl={3} >
          <Card className="shadow-sm border-0 h-100">
            <Card.Body>
              <h6 className="text-center info-homepage mb-1">------------------------------------</h6>
              <h6 className="text-center info-homepage mb-1">INFORMAZIONI DA INSERIRE</h6>
              <h6 className="text-center info-homepage mb-4">------------------------------------</h6>

              <Form onSubmit={handleSubmit}>

                <Form.Group controlId="formTypeLicense" className="mb-4">
                  <Form.Label><strong>Tipologia Targa</strong></Form.Label>
                  <Form.Select
                    value={typeLicense}
                    onChange={(e) => setTypeLicense(e.target.value)}
                    required
                  >
                    <option value="">-- Seleziona Targa --</option>
                    <option value="CE">CE</option>
                    <option value="UL">UL</option>
                  </Form.Select>
                </Form.Group>

                <Form.Group controlId="formTypeLanguage" className="mb-4">
                  <Form.Label><strong>Tipologia Lingua</strong></Form.Label>
                  <Form.Select
                    value={language}
                    onChange={(e) => setLanguage(e.target.value)}
                    required
                  >
                    <option value="">-- Seleziona Lingua --</option>
                    {languages.map((lang) => (
                      <option key={lang} value={lang}>
                        {lang}
                      </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                <Form.Group controlId="formTypeMachine" className="mb-4">
                  <Form.Label><strong>Tipologia Macchina</strong></Form.Label>
                  <Form.Select
                    value={typeMachineSelected}
                    onChange={(e) => setTypeMachineSelected(e.target.value)}
                    required
                  >
                    <option value="">-- Seleziona Macchina --</option>
                    {typeMachine
                      .filter(item => item.name !== "denominazione")
                      .map(item => (
                        <option key={item.name} value={item.name}>
                          {item.name}
                        </option>
                    ))}
                  </Form.Select>
                </Form.Group>

                {typeMachineSelected && (
                  <>
                    <Form.Group controlId="formSNMachine" className="mb-4">
                      <Form.Label><strong>Serial Number Macchina</strong></Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Esempio: V1.01.01.01"
                        value={snMachine}
                        onChange={(e) => setSnMachine(e.target.value)}
                        required
                      />
                    </Form.Group>

                    <Form.Group controlId="formTypeLaser" className="mb-4">
                      <Form.Label><strong>Tipologia Laser</strong></Form.Label>
                      <Form.Select
                        value={typeLaser}
                        onChange={(e) => setTypeLaser(e.target.value)}
                        required
                      >
                        <option value="">-- Seleziona Laser --</option>
                        {laserOptions.map((laser, idx) => (
                          <option key={idx} value={laser}>{laser}</option>
                        ))}
                      </Form.Select>
                    </Form.Group>
                
                    <Form.Group controlId="formVoltage" className="mb-4">
                      <Form.Label><strong>Tensione [V]</strong></Form.Label>
                      <Form.Select
                        value={voltage}
                        onChange={(e) => setVoltage(e.target.value)}
                        required
                      >
                        <option value="">-- Seleziona Tensione --</option>
                        {[380, 400, 415, 440, 460, 480].map(v => (
                          <option key={v} value={v}>{v} V</option>
                        ))}
                      </Form.Select>
                    </Form.Group>

                    <Form.Group controlId="formFrequency" className="mb-4">
                      <Form.Label><strong>Frequenza [Hz]</strong></Form.Label>
                      <Form.Select
                        value={frequency}
                        onChange={(e) => setFrequency(e.target.value)}
                        required
                      >
                        <option value="">-- Seleziona Frequenza --</option>
                        {typeLicense === "CE" && <option value="50">50 Hz</option>}
                        <option value="60">60 Hz</option>
                      </Form.Select>
                    </Form.Group>
                  </>
                )}

                <div className="text-center mt-4">
                  <Button
                    type="submit"
                    variant="primary"
                    size="lg"
                    disabled={
                      !typeLicense || !snMachine.trim() || !typeLaser || !frequency || (typeLicense === "CE" && !voltage)
                    }
                  >
                    ANALISI
                  </Button>
                </div>
              </Form>

              {/* RIEPILOGO DATI INSERITI */}
              {submittedData && (
                <Card className="mt-4 bg-light border-0 shadow-sm">
                  <Card.Body>
                    <h6 className="text-center text-secondary mb-3">
                      <strong>Riepilogo Dati Inseriti</strong>
                    </h6>
                    <ul className="list-unstyled small mb-0">
                      <li>🔹 <strong>Tipologia Targa:</strong> {submittedData.typeLicense}</li>
                      <li>🔹 <strong>Lingua:</strong> {submittedData.language}</li>
                      <li>🔹 <strong>Seriale:</strong> {submittedData.snMachine}</li>
                      <li>🔹 <strong>Laser:</strong> {submittedData.typeLaser}</li>
                      <li>🔹 <strong>Tensione:</strong> {submittedData.voltage} V</li>
                      <li>🔹 <strong>Frequenza:</strong> {submittedData.frequency} Hz</li>
                    </ul>
                  </Card.Body>
                </Card>
              )}
            </Card.Body>
          </Card>
        </Col>


        {/* COLONNA CENTRALE — IMMAGINI */}
        <Col xl={5}>
          {results && (
            <Card className="shadow-sm border-0 text-center p-4 bg-light">
              <Card.Body className="d-flex flex-column justify-content-center align-items-center gap-4">
                <img
                  src={Img1}
                  alt="Riferimento 1"
                  className="img-fluid rounded shadow"
                  style={{
                    width: "100%",
                    height: "auto",          // scala liberamente
                    maxWidth: "600px",       // optional, evita immagini troppo larghe
                  }}
                />
                <img
                  src={Img2}
                  alt="Riferimento 2"
                  className="img-fluid rounded shadow"
                  style={{
                    width: "100%",
                    height: "auto",
                    maxWidth: "600px",
                  }}
                />
              </Card.Body>
            </Card>
          )}
        </Col>


        {/* COLONNA DESTRA — RISULTATI */}
        <Col xl={4}>
          {results && (
            <Card className="shadow-sm border-0 h-200">
              <Card.Body>
                <div className="results-box">
                  {Object.entries(results).map(([key, value], index) => (
                    <div key={index} className="result-item mb-2">
                      <span className="fw-bold text-secondary">{index + 1}:</span> {value}
                    </div>
                  ))}
                </div>
              </Card.Body>
            </Card>
          )}
        </Col>
      </Row>
    </Container>
  );
}

export default HomePage;
